import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FormHelperText } from "@mui/material";

export default function SelectInput({
  labelName,
  isDisable,
  helperText,
  error,
  placeholder,
  value,
  onChange,
  options,
  name,
  id,
  noLabel,
  disable
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  // console.log(disable, 145);

  useEffect(() => {
    const handleScroll = () => {
      if (menuOpen) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
}, [menuOpen]);

  const handleOpen = () => {
    setMenuOpen(true);
  };

  const handleClose = () => {
    setMenuOpen(false);
  };

  return (
    <Box>
      {!noLabel ? (
        <label className="input-label my-2">
          {labelName}
          <span style={{ color: "red" }}>*</span>
        </label>
      ) : null}

      <FormControl error={error} fullWidth>
        <InputLabel size="small" id={name}>
          {placeholder}
        </InputLabel>
        <Select
         sx={{
          color: disable ? "#000 !important" : "inherit", // Keeps text color the same when disabled
          "&.Mui-disabled": {
           "-webkit-text-fill-color": "rgba(0, 0, 0, 1) !important", // For Safari
          },
        }}
          className="text-capitalize text-dark"
          disabled={isDisable || disable ? true : false}
          labelId={name}
          id={id}
          value={value}
          label={placeholder}
          size="small"
          onChange={onChange}
          name={name}
          MenuProps={{
            open: menuOpen,
            onClose: handleClose,
            size: "small",
            disableScrollLock: true,
          }}
          onOpen={onChange? handleOpen:null}
        >
          {options?.map((option) => {
            return (
              <MenuItem
                key={option?._id}
                onClick={handleClose}
                value={option?._id}
                className="text-capitalize"
              >
                {option?.name}
              </MenuItem>
            );
          })}
        </Select>
        <FormHelperText name={helperText}>{helperText}</FormHelperText>
      </FormControl>
    </Box>
  );
}
